import { useMutation } from '@tanstack/react-query';
import apiClient from '../lib/api/client';

export function useIncrementSeriesViews() {
  return useMutation({
    mutationFn: async (seriesId: string) => {
      await apiClient.post(`/streaming/series/${seriesId}/views`);
    },
  });
}
